export const consentsCz = {
  // Direct translations for consent types - can be used with transloco
  PRIVACY_POLICY: 'Zásady ochrany soukromí',
  TERMS_OF_USE: 'Podmínky použití',
  MARKETING: 'Marketingová komunikace',
  AI_MATCHING: 'AI párování pracovních pozic',
  AI_PARSING: 'AI analýza životopisu',
  COOKIES: 'Cookies',
  ANALYTICS: 'Analýzy a statistiky',
  THIRD_PARTY_SHARING: 'Sdílení údajů s třetími stranami',

  // Descriptions
  descriptions: {
    PRIVACY_POLICY: 'Souhlas se Zásadami ochrany soukromí je nutný pro používání našich služeb a zpracování vašich osobních údajů.',
    TERMS_OF_USE: 'Souhlas s Podmínkami použití je povinný pro přístup a používání našich služeb.',
    MARKETING: 'Dostávejte propagační e-maily, newslettery a marketingovou komunikaci o našich službách, pracovních příležitostech a speciálních nabídkách.',
    AI_MATCHING:
      'Když je zapnuto, Sameta může analyzovat váš profil, údaje ze životopisu, preference a aktivitu, aby vám doporučovala relevantní pracovní nabídky a podpořila AI párování pro recruitery. Vypněte ho, pokud nechcete automatizované párování.',
    AI_PARSING:
      'Když je zapnuto, Sameta může použít AI ke čtení nahraného životopisu a předvyplnění polí profilu. Šetří to čas při úpravě profilu a je to oddělené od AI párování.',
    COOKIES: 'Povolte nám používat cookies ke zlepšení vašeho zážitku z prohlížení, zapamatování preferencí a poskytování personalizovaného obsahu.',
    ANALYTICS: 'Povolte nám sbírat anonymní statistiky používání a analytická data ke zlepšení našich služeb a pochopení chování uživatelů.',
    THIRD_PARTY_SHARING: 'Povolte nám sdílet vaše údaje s důvěryhodnými partnery za účelem párování pracovních pozic a náboru.',
  },

  // UI labels and content
  pages: {
    settings: {
      consents: {
        title: 'Správa souhlasů',
        description:
          'Spravujte své preference ochrany soukromí a souhlasy se zpracováním údajů. Souhlas s různými aktivitami zpracování údajů můžete kdykoli udělit nebo odvolat.',
        loading: 'Načítám vaše preference souhlasů...',
        categories: {
          essential: 'Základní souhlasy',
          essentialDescription: 'Tyto souhlasy jsou potřebné pro základní funkčnost našich služeb a nelze je vypnout.',
          optional: 'Volitelné souhlasy',
          optionalDescription: 'Tyto souhlasy jsou volitelné a pomáhají nám zlepšovat naše služby. Můžete je kdykoli povolit nebo zakázat.',
        },
        grantedOn: 'Uděleno dne',
        withdrawnOn: 'Odvoláno dne',
        version: 'Verze',
        required: 'Povinné',
        footerInfo:
          'Změny vašich preferencí souhlasů se projeví okamžitě. Tato nastavení můžete kdykoli upravit. Pro více informací o tom, jak zpracováváme vaše údaje, si přečtěte naše',
      },
    },
  },
};
